/**
 * Pushes one event onto a dataLayer array in either gtag or GTM shape. Pure
 * function, no tracker-specific state -- shared by every tracker so the wire
 * format BigQuery/GA4 parses stays defined in exactly one place.
 */

export type DataLayerTransport = "gtag" | "gtm";

export interface PushDataLayerEventArgs {
  dataLayer: unknown[];
  transport: DataLayerTransport;
  measurementId?: string;
  eventName: string;
  fields: Record<string, unknown>;
}

export function pushDataLayerEvent({
  dataLayer,
  transport,
  measurementId,
  eventName,
  fields,
}: PushDataLayerEventArgs): void {
  if (!dataLayer) return;
  if (transport === "gtm") {
    dataLayer.push({ event: eventName, ...fields });
  } else {
    const gtagFields = measurementId
      ? { ...fields, send_to: measurementId }
      : fields;
    // Pushing this gtag()-shaped array is equivalent to calling window.gtag(...)
    // directly (gtag() is itself just dataLayer.push(arguments)), but doesn't
    // depend on window.gtag having been assigned yet -- gtag.js drains any
    // already-queued dataLayer entries once it finishes loading.
    dataLayer.push(["event", eventName, gtagFields]);
  }
}
